module.exports = __webpack_public_path__ + "img/center-intro-structure2-1.a278ed1e.png";